import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Box, MenuItem, Select, Typography, useTheme } from '@mui/material';
import React from 'react';

interface IProps {
  value: number;
  options: number[];
  onChange: (value: number) => void;
  label?: string;
}

export const ItemsPerPage: React.FC<IProps> = ({ value, options, onChange, label = 'Items per page:' }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'baseline',
        gap: 1,
      }}
    >
      <Typography
        sx={{
          fontSize: 14,
          color: theme.sass.ebony,
        }}
      >
        {label}
      </Typography>
      <Select
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        IconComponent={ArrowDropDownIcon}
        data-action="items_per_page_select"
        sx={{
          fontSize: 14,
          '.MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '.MuiSelect-select': {
            padding: '4px 24px 5px 8px',
          },
          '.MuiSelect-icon': {
            color: 'rgba(0, 0, 0, 0.54)',
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option} value={option} data-action={`items_per_page_option_${option}`}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
